import React from 'react';
import { withTranslation } from 'react-i18next';
import config from '../../config';
import { history } from '../../routes';

import Button from '../../components/commons/Button';
import img from '../../assets/img/instructive.png';

import instructive_feed from '../../assets/img/onboarding/instructive-feed.png'
import instructive_challenge_1 from '../../assets/img/onboarding/instructive-challenge-1.png'
import instructive_challenge_2 from '../../assets/img/onboarding/instructive-challenge-2.png'
import instructive_loans_1 from '../../assets/img/onboarding/instructive-loans-1.png'
import instructive_loans_2 from '../../assets/img/onboarding/instructive-loans-2.png'
import instructive_loans_3 from '../../assets/img/onboarding/instructive-loans-3.png'
import instructive_loans_4 from '../../assets/img/onboarding/instructive-loans-4.png'
import instructive_actions_1 from '../../assets/img/onboarding/instructive-actions-1.png'
import instructive_actions_2 from '../../assets/img/onboarding/instructive-actions-2.png'
import instructive_actions_3 from '../../assets/img/onboarding/instructive-actions-3.png'
import instructive_credits_1 from '../../assets/img/onboarding/instructive-credits-1.png'
import instructive_credits_2 from '../../assets/img/onboarding/instructive-credits-2.png'

import Icon from '../../libraries/icons';

//const images = Object.freeze({ slide0, slide1, slide2, slide3 });
class Instructive extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
      already_seen: false,
      closed: false,
      slides: [],
      slide: 0,
      imgs: {
        "instructive_feed": instructive_feed, 
        "instructive_challenge_1": instructive_challenge_1, 
        "instructive_challenge_2": instructive_challenge_2, 
        "instructive_actions_1": instructive_actions_1, 
        "instructive_actions_2": instructive_actions_2, 
        "instructive_actions_3": instructive_actions_3, 
        "instructive_loans_1": instructive_loans_1, 
        "instructive_loans_2": instructive_loans_2, 
        "instructive_loans_3": instructive_loans_3, 
        "instructive_loans_4": instructive_loans_4, 
        "instructive_credits_1": instructive_credits_1, 
        "instructive_credits_2": instructive_credits_2, 
      }
    }
  }
  
  componentDidMount() {
    console.log('Instructive PAGE', );
    
    if (localStorage.getItem(this.props.instructive)) {
      let already_seen = !JSON.parse(localStorage.getItem(this.props.instructive))
      this.setState({already_seen, closed: already_seen, slides: this.props.slides})
    } else {
      let closed = this.props.slides.length < 1
      this.setState( { slides: this.props.slides, closed} )
    }
    // console.log("INSTRUCTIVE==================",!JSON.parse(localStorage.getItem(this.props.instructive)))
  }
  componentDidUpdate(prevProps, prevState) {
    if(this.props.slides !== prevProps.slides){
      if (localStorage.getItem(this.props.instructive)) {
        let already_seen = !JSON.parse(localStorage.getItem(this.props.instructive))
        this.setState({already_seen, closed: already_seen, slides: this.props.slides})
      } else {
        let closed = this.props.slides.length < 1
        this.setState( { slides: this.props.slides, closed} )
      }
    }
  }
 

  onPressOk = () => {
    //config.SLIDER_SCREEN
    let slide = this.state.slide;
    if (slide < this.state.slides.length -1) {
      slide++;
      this.setState({ slide });
    } else {
      localStorage.setItem(this.props.instructive, JSON.stringify(false));
      this.setState({closed: true})
    }
  }; 
  goToBack = () => {
    history.replace(config.ROUTES.HOME);
  }

  render() {
    const { slide, slides, imgs } = this.state;
    console.log("slides[slide]", slides[slide]?.img)
    if(this.state.closed) return <>{this.props.children}</>;
    return (
      <main className="h-full z-[60] absolute top-0 left-0 w-full text-center pt-20 bg-primary bg-opacity-70">
        <div className="container p-10 rounded-t-2xl md:rounded-2xl bg-white max-w-md mx-auto w-full h-full md:h-auto flex flex-col items-center justify-around md:justify-start relative">
        { (slides[slide] &&slides[slide]?.isNonClosable == true)&&<div className='absolute top-8 right-8 cursor-pointer' onClick={this.goToBack}>
            <Icon name="close" className="w-5 h-5" color={"black"} />
         </div>}
          {
            <>
              <div className="h-80 md:h-max-80 flex items-center overflow-hidden">
                <img className='w-[80%] mx-auto' src={imgs[slides[slide]?.img]} alt="" />
              </div>
              <div className="p-3">
                <h1 className="text-primary text-2xl mb-5">{this.t(slides[slide]?.title)}</h1>
                <p className="text-gray-600 mb-10">{this.t(slides[slide]?.body)}</p>
              </div>
             { !(slides[slide]?.isNonClosable == true)&& <Button
                className="btn-outline bg-base-200 btn-primary pointer-events-auto uppercase"
                title={this.t(`${this.props.labelButton??"¡Vamos a ver!"}`)}
                onClick={this.onPressOk}
              />}

              <div className='w-3 h-3 rounded-full bg-base-200 mt-5'></div>
            </>
          }
        </div>
      </main>
    ) 
  }
}

export default withTranslation()(Instructive);
